// extracted by mini-css-extract-plugin
export var actions = "_mj-g";
export var benefitCard = "_mj-b";
export var benefitIcon = "_mj-d";
export var benefitLabel = "_mj-f";
export var benefits = "_mj-a";
export var benefitsSection = "_mj-8";
export var bodyText = "_mj-7";
export var closeButton = "_mj-2";
export var content = "_mj-3";
export var eyebrow = "_mj-4";
export var heading = "_mj-5";
export var image = "_mj-i";
export var imagePanel = "_mj-h";
export var modal = "_mj-0";
export var offerCard = "_mj-c";
export var offerIcon = "_mj-e";
export var sectionLabel = "_mj-9";
export var shell = "_mj-1";
export var title = "_mj-6";